import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { provideParentFormGroup } from '../forms.utils';
import { FormBaseComponent } from '../form-base/form-base.component';

@Component({
  selector: 'app-form-datepicker',
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, MatInputModule, MatDatepickerModule, MatIconModule],
  templateUrl: './form-datepicker.component.html',
  styleUrls: ['./form-datepicker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideParentFormGroup()],
})
export class FormDatepickerComponent extends FormBaseComponent {}
